import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        /*
        async searchMachineTypeByString({ querystring, includeInactive }) {
            var meta = {
                clientApiMethod: 'searchTypeByString',
                input: { querystring: querystring, includeInactive: includeInactive }
            }
            var query ="?searchQuery=" + querystring + "&IncludeInactive=" + includeInactive;
            var response = await client().get(store.state.apiRouteRoot + "MachineType/search" + query, { meta: meta })
            return response.data;
        },
        */
        async getMachineTypeListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getMachineTypeListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "MachineType/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getMachineTypeList() {
            var response = await client().get(store.state.apiRouteRoot + 'MachineType', { meta: { clientApiMethod: 'getMachineTypeList' } })
            return response?.data;
        },
        async getMachineTypeById(typeId) {
            var meta = { clientApiMethod: 'getMachineTypeById', input: { typeId: typeId } }
            var response = await client().get(store.state.apiRouteRoot + "MachineType/" + typeId, { meta: meta })
            return response?.data;
        },
        async createMachineType(newMachineType) {
            var meta = {
                clientApiMethod: 'createMachineType',
                input: { newMachineType },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.machine_type.machine_type") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'MachineType', newMachineType, { meta: meta })
            return response?.data;
        },
        async updateMachineType(updatedMachineType) {
            var meta = {
                clientApiMethod: 'updateMachineType',
                input: { updatedMachineType },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine_type.machine_type") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'MachineType', updatedMachineType, { meta: meta })
            return response?.data;
        },

        async deleteMachineTypeServiceAgreement(id) {
            var meta = {
                clientApiMethod: 'deleteMachineTypeServiceAgreement',
                input: { id: id },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine_type.machine_type") })
            }
            var response = await client().delete(store.state.apiRouteRoot + 'MachineType/ServiceAgreement/' + id, { meta: meta })
            return response?.data;
        },
    }
}